<template>
  <div>
    
    <Modal title="Title" v-model="showModal" :mask-closable="false" width="380">
      <Spin fix v-show="isSpinShow" size="large" />
      <p slot="header" style="color:#ff9900;text-align:center">
        <span>请选择您的设备</span>
      </p>
      <div style="text-align:center">
        <div style="margin-bottom: 10px">
          <Select v-model="selectedMeter" style="margin-left:10px; width:150px" placeholder="请选择设备">
            <Option
              v-for="(value, key) in meterList"
              :value="JSON.stringify(value)"
              :key="key"
            >{{value.meterId + value.completeAddress}}</Option>
          </Select>
        </div>
      </div>
      <div slot="footer">
        <Button :loading="isLoading" type="warning" size="large" @click="selectMeterClick" long>确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    customerInfo: {},
    selectedIdentity: "",
    selectedCustomer:{},
    callBack: {
      type: Function
    }
  },
  mounted() {},
  data() {
    return {
      isLoading: false,
      selectedMeter: "",
      meterList: [],
      conditions: {},
      showModal: false,
      target: "",
      isSpinShow: ""
    };
  },
  methods: {
    initModal(param) {
      // 获得目标源页面
      this.target = param;
      this.showModal = true;
      this.selectedMeter = "";
      this.isLoading = false;

      console.log(this.customerInfo);

      if (this.selectedIdentity == "nothouseholder") {
        this.getMeterInfo();
      } else {
        console.log(this.customerInfo["customerIdcard"]);
        this.conditions["customerIdCard"] = this.customerInfo["customerIdcard"];
        this.getMeterInfo();
      }
    },
    selectMeterClick() {
      if (this.selectedMeter == "" || this.selectedMeter == undefined) {
        this.$Modal.info({
          title: "提示",
          content: "请选择您的设备！"
        });
      } else {
        this.isLoading = true;
        // callBack传回目标源页面
        this.callBack(this.selectedMeter, this.target);
        this.showModal = false;
      }
    },
    getMeterInfo() {
      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/getMeterInfoByConditions",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: null,
          amount: null,
          conditions: that.conditions,
          type: that.selectedIdentity,
          selectedCustomer: that.selectedCustomer
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.meterList = data.body.resultList;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    }
  }
};
</script>
